import StripeForm from 'routes/ReferralForm/FormStripeView/components/StripeForm/StripeForm';

export default StripeForm;
